// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_cmp_api = require("./MM_cmp_api.res.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Raw_js_utils = require("../utils/Raw_js_utils.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var List = require("@mui/material/List").default;
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Paper = require("@mui/material/Paper").default;
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Button = require("@mui/material/Button").default;
var Divider = require("@mui/material/Divider").default;
var MM_wrk_frag_transform = require("../worker/MM_wrk_frag_transform.res.js");
var ListItem = require("@mui/material/ListItem").default;
var MM_cmp_single_frag_transf = require("./MM_cmp_single_frag_transf.res.js");
var ListItemText = require("@mui/material/ListItemText").default;
var ListItemButton = require("@mui/material/ListItemButton").default;

var transformsTextCache = {
  contents: []
};

var allTransformsCache = {
  contents: []
};

function createInitialState(step, ctxConstIntToSymExn) {
  return {
          step: MM_cmp_api.stmtToJson(step, ctxConstIntToSymExn),
          transformsParseErr: undefined,
          availableTransforms: undefined,
          selectedTransform: undefined
        };
}

function setTransformsParseErr(st, str) {
  return {
          step: st.step,
          transformsParseErr: str,
          availableTransforms: st.availableTransforms,
          selectedTransform: st.selectedTransform
        };
}

function setAvailableTransforms(st, elem) {
  return {
          step: st.step,
          transformsParseErr: st.transformsParseErr,
          availableTransforms: Caml_option.some(elem),
          selectedTransform: st.selectedTransform
        };
}

function setSelectedTransform(st, tr) {
  return {
          step: st.step,
          transformsParseErr: st.transformsParseErr,
          availableTransforms: st.availableTransforms,
          selectedTransform: tr
        };
}

function MM_cmp_frag_transform(props) {
  var onCancel = props.onCancel;
  var onUpdateCurrent = props.onUpdateCurrent;
  var onInsertBelow = props.onInsertBelow;
  var onInsertAbove = props.onInsertAbove;
  var transformsText = props.transformsText;
  var ctxConstIntToSymExn = props.ctxConstIntToSymExn;
  var step = props.step;
  var match = React.useState(function () {
        return createInitialState(step, ctxConstIntToSymExn);
      });
  var setState = match[1];
  var state = match[0];
  var rndAvailableTransforms = function (availableTransforms) {
    var param = {
      step: state.step
    };
    var listItems = Raw_js_utils.invokeExnFunc("Listing available transforms", (function () {
            return availableTransforms.map(function (availableTransform, i) {
                        return JsxPPXReactSupportU.createElementWithKey(String(i), ListItem, {
                                    disablePadding: true,
                                    children: Caml_option.some(React.createElement(ListItemButton, {
                                              onClick: (function (param) {
                                                  setState(function (__x) {
                                                        return setSelectedTransform(__x, availableTransform);
                                                      });
                                                }),
                                              children: Caml_option.some(React.createElement(ListItemText, {
                                                        children: Caml_option.some(availableTransform.displayName(param))
                                                      }))
                                            }))
                                  });
                      });
          }));
    if (listItems.TAG === "Ok") {
      return {
              TAG: "Ok",
              _0: React.createElement(List, {
                    disablePadding: true,
                    children: Caml_option.some(listItems._0)
                  })
            };
    } else {
      return {
              TAG: "Error",
              _0: listItems._0
            };
    }
  };
  React.useEffect((function () {
          var param = {
            step: state.step
          };
          if (Caml_obj.notequal(transformsText, transformsTextCache.contents)) {
            var allTransformsRef = {
              contents: []
            };
            var availableTransformsElem = Belt_Result.flatMap(Belt_Result.flatMap(MM_wrk_frag_transform.arrStrToFragTransforms(transformsText), (function (allTransforms) {
                        allTransformsRef.contents = allTransforms;
                        return Raw_js_utils.invokeExnFunc("Getting available transforms", (function () {
                                      return allTransforms.filter(function (tr) {
                                                  return tr.canApply(param);
                                                });
                                    }));
                      })), rndAvailableTransforms);
            if (availableTransformsElem.TAG === "Ok") {
              var availableTransformsElem$1 = availableTransformsElem._0;
              transformsTextCache.contents = transformsText;
              allTransformsCache.contents = allTransformsRef.contents;
              setState(function (__x) {
                    return setAvailableTransforms(__x, availableTransformsElem$1);
                  });
            } else {
              var msg = availableTransformsElem._0;
              setState(function (__x) {
                    return setTransformsParseErr(__x, msg);
                  });
            }
          } else {
            var availableTransformsElem$2 = Belt_Result.flatMap(Raw_js_utils.invokeExnFunc("Getting available transforms from cache", (function () {
                        return allTransformsCache.contents.filter(function (tr) {
                                    return tr.canApply(param);
                                  });
                      })), rndAvailableTransforms);
            if (availableTransformsElem$2.TAG === "Ok") {
              var availableTransformsElem$3 = availableTransformsElem$2._0;
              setState(function (__x) {
                    return setAvailableTransforms(__x, availableTransformsElem$3);
                  });
            } else {
              var msg$1 = availableTransformsElem$2._0;
              setState(function (__x) {
                    return setTransformsParseErr(__x, msg$1);
                  });
            }
          }
        }), []);
  var actUnselectTransform = function () {
    setState(function (__x) {
          return setSelectedTransform(__x, undefined);
        });
  };
  var rndButtons = function () {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        onCancel();
                      }),
                    variant: "outlined",
                    children: "Cancel"
                  }), MM_react_common.rndHiddenTextField(undefined, MM_react_common.kbrdHnds([MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onCancel)])));
  };
  var rndContent = function () {
    var msg = state.transformsParseErr;
    if (msg !== undefined) {
      return React.createElement(Expln_React_Column.make, {
                  children: Caml_option.some(null)
                }, React.createElement("span", undefined, "Please make sure the custom transforms script is non-blank and valid or the \"Use custom transforms\" setting is unchecked."), React.createElement("pre", undefined, "Error: " + msg));
    }
    var selectedTransform = state.selectedTransform;
    if (selectedTransform !== undefined) {
      return React.createElement(MM_cmp_single_frag_transf.make, {
                  step: state.step,
                  transform: selectedTransform,
                  onBack: actUnselectTransform,
                  onInsertAbove: onInsertAbove,
                  onInsertBelow: onInsertBelow,
                  onUpdateCurrent: onUpdateCurrent
                });
    }
    var availableTransforms = state.availableTransforms;
    if (availableTransforms !== undefined) {
      return Caml_option.valFromOption(availableTransforms);
    } else {
      return "Loading available transforms...";
    }
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, rndContent(), React.createElement(Divider, {}), rndButtons()))
            });
}

var make = MM_cmp_frag_transform;

exports.transformsTextCache = transformsTextCache;
exports.allTransformsCache = allTransformsCache;
exports.createInitialState = createInitialState;
exports.setTransformsParseErr = setTransformsParseErr;
exports.setAvailableTransforms = setAvailableTransforms;
exports.setSelectedTransform = setSelectedTransform;
exports.make = make;
/* react Not a pure module */
